import React from 'react';
import ForwardValuationWidgetBuilder from './ForwardValuationWidgetBuilder';
import ForwardValuationWidgetRenderer from './ForwardValuationWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { ForwardValuationWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';

export { default as ForwardValuationWidgetRenderer } from './ForwardValuationWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'forward_valuation',
  meta: {
    label: 'Forward Valuation',
    icon: React.createElement(FontAwesomeIcon, { icon: faChartLine }),
    description: 'NTM and out-year forward P/E and EV/EBITDA from consensus estimates',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'FORWARD_VALUATION',
  },
  defaultSize: { w: 6, h: 5, minW: 4, minH: 4 },
  defaultConfig: () => ({} as ForwardValuationWidgetConfig),
  Builder: ForwardValuationWidgetBuilder,
  Renderer: ForwardValuationWidgetRenderer,
  Preview,
};
